import React from 'react'
import HeaderBanner from '../ui/HeaderBanner'

const Awards = () => {
    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
            <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
                <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
                            <stop stopColor="#FFF" offset="0%" />
                            <stop stopColor="#EAEAEA" offset="77.402%" />
                            <stop stopColor="#DFDFDF" offset="100%" />
                        </linearGradient>
                    </defs>
                    <g fill="url(#illustration-01)" fillRule="evenodd">
                        <circle cx="1232" cy="128" r="128" />
                        <circle cx="155" cy="443" r="64" />
                    </g>
                </svg>
            </div>
            
            <HeaderBanner title={'Awards'} />
            
            <div className="text-left space-y-8 pt-12">
                {/* Best Paper Awards Section */}
                <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
                    <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-4">
                        Best Paper Awards
                    </h1>
                    <div className="space-y-4">
                        <p className="text-gray-700 leading-relaxed">
                            At every conference within SSD, a <span className='font-semibold text-red-600'>Best Paper Award</span> will be provided to recognize the outstanding paper, which reports about an original and significant contribution to the corresponding field.
                        </p>
                        <p className="text-gray-700 leading-relaxed">
                            A five-member jury of experts will carry out the selection of the best paper. The criteria for selecting the best paper are:
                        </p>
                    </div>
                </div>

                {/* Criteria Section */}
                <div className="bg-gray-50 border-l-4 border-red-500 p-6 rounded-lg shadow-sm">
                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Selection Criteria</h2>
                    <ul className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                        <li className='text-blue-902 hover:text-white bg-white border border-blue-901 p-4 rounded-lg shadow-sm hover:shadow-md hover:bg-blue-901 transition-all duration-300 cursor-pointer'>
                            <p className='text-center font-semibold '>Originality and degree of innovation</p>
                        </li>
                        <li className='text-blue-902 hover:text-white bg-white border border-blue-901 p-4 rounded-lg shadow-sm hover:shadow-md hover:bg-blue-901 transition-all duration-300 cursor-pointer'>
                            <p className='text-center font-semibold '>Scientific, technical, or applied importance</p>
                        </li>
                        <li className='text-blue-902 hover:text-white bg-white border border-blue-901 p-4 rounded-lg shadow-sm hover:shadow-md hover:bg-blue-901 transition-all duration-300 cursor-pointer'>
                            <p className='text-center font-semibold '>Review results</p>
                        </li>
                        <li className='text-blue-902 hover:text-white bg-white border border-blue-901 p-4 rounded-lg shadow-sm hover:shadow-md hover:bg-blue-901 transition-all duration-300 cursor-pointer'>
                            <p className='text-center font-semibold '>Low similarity rating</p>
                        </li>
                        <li className='text-blue-902 hover:text-white bg-white border border-blue-901 p-4 rounded-lg shadow-sm hover:shadow-md hover:bg-blue-901 transition-all duration-300 cursor-pointer'>
                            <p className='text-center font-semibold '>Clarity of writing and oral presentation</p>
                        </li>
                    </ul>
                </div>

                {/* Additional Information Section */}
                <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
                    <h3 className="text-lg font-semibold text-red-600 mb-2">
                        Award Recognition
                    </h3>
                    <p className="text-gray-700">
                        The Best Paper Award winners will be recognized during the conference ceremony and will receive a certificate of achievement. For more details about the awards process, contact:{' '}
                        <a className='text-red-600 hover:text-red-800 font-medium underline' href='mailto:info@ssd-multiconf.org'>
                            info@ssd-multiconf.org
                        </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Awards